module.exports = __webpack_public_path__ + "img/following.7e36f0b6.svg";